import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { SortDescriptor } from '@progress/kendo-data-query';
import { MappingType } from 'app/modules/shared/interfaces/mapping-type';
import { ToastService } from 'app/modules/shared/services/toast.service';
import { ClientLookupDataModel, ClientLookupMappingModel, ClientLookupParamsModel } from '../../interfaces/client-lookup';
import { ClientLookupService } from '../../services/client-lookup.service';

@Component({
    selector: 'app-loan-characteristics-mapping',
    templateUrl: './loan-characteristics-mapping.component.html',
    styleUrls: ['./loan-characteristics-mapping.component.scss']
})
export class LoanCharacteristicsMappingComponent implements OnInit {
    /* Tab Scroller */
    @ViewChild('mappingTabBar') mappingTabBar: MatTabGroup;
    tabs = [];
    tabActiveIndex: number = 0;
    mappingTypes: MappingType[];
    mappingSort: SortDescriptor[] = [
        { field: 'clientTag', dir: 'asc' }
    ];
    mappingTitle: string = 'Test';
    mappings: Array<ClientLookupMappingModel> = [];
    selectedMapping: ClientLookupMappingModel;
    loading: boolean = false;

    constructor(private clientLookupService: ClientLookupService) { }

    ngOnInit() {
        this.getClientMappings();
    }

    getClientMappings() {
        this.loading = true;
        this.clientLookupService.getLookupDataTypes().subscribe(
            (lookupDataTypes) => {
                lookupDataTypes.forEach(
                    (lookupDataType, index) => {
                        this.tabs.push({ label: lookupDataType.lookupDataType, 
                                         abbv: lookupDataType.lookupTypeAbbv });
                        let lookupAbbv = lookupDataType.lookupTypeAbbv;
                        let clientLookupParams: ClientLookupParamsModel = {
                            lookupDataTypeAbbv: lookupAbbv
                        };
                        this.clientLookupService.getClientLookupMappings(clientLookupParams).subscribe(
                            (data) => {
                                this.getLookupTypes(data, lookupDataType.lookupDataType, lookupAbbv, index);
                            },
                            (error) => {
                                this.loading = false;
                                throw new Error(error);
                            }
                        );
                    }
                )
            },
            (error) => {
                this.loading = false;
                throw new Error(error);
            }
        )
    }

    getLookupTypes(lookupData: any, mappingTitle: string, lookupAbbv: string, index: number): object[] {
        let clientLookupParams: ClientLookupParamsModel = {
            lookupDataTypeAbbv: lookupAbbv
        };

        this.clientLookupService.getLookupValues(clientLookupParams).subscribe(
            (data) => {
                this.mappings[index] = {
                    clientLookupDataModel: lookupData.map(value => this.formatMappingData(value)),
                    mappingDescription: `See your list of ${mappingTitle} mappings here`,
                    mappingTypes: data.map((value) => this.lookupValueToMappingType(value)),
                    mappingTitle: mappingTitle, 
                    lookupAbbv: lookupAbbv
                };

                // Set the first selected mapping
                if(index == 0) {
                    this.selectedMapping = this.mappings[index];
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                throw new Error(error);
            }
        );

        return null;
    }

    lookupValueToMappingType(lookupValue: ClientLookupDataModel): MappingType {
        return {
            typeKey: lookupValue.lookupValueKey,
            typeValue: lookupValue.lookupValue
        };
    }

    formatMappingData(value: ClientLookupDataModel) {
        return {
            clientTag: value.clientTag,
            lookupValue: value.lookupValue,
            lookupValueKey: value.lookupValueKey,
            typeKey: value.lookupValueKey
        }
    }

    /* Tab Scroller */
    tabChangeHandler(event) {
        let index: number = event.index;
        this.tabActiveIndex = index;
        this.selectedMapping = this.mappings[index];
    }

    previousClicked() {
        this.mappingTabBar.selectedIndex = --this.tabActiveIndex;
    }

    nextClicked() {
        this.mappingTabBar.selectedIndex = ++this.tabActiveIndex;
    }

    isActiveTab(index: number) {
        return this.tabActiveIndex === index;
    }
}
